"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _BaseClient2 = _interopRequireDefault(require("./BaseClient"));

var AccountsClient =
/*#__PURE__*/
function (_BaseClient) {
  (0, _inherits2["default"])(AccountsClient, _BaseClient);

  function AccountsClient(getAccessToken) {
    (0, _classCallCheck2["default"])(this, AccountsClient);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(AccountsClient).call(this, getAccessToken, 'https://accounts.cimpress.io'));
  }

  (0, _createClass2["default"])(AccountsClient, [{
    key: "getAccount",
    value: function getAccount(accountId) {
      return this.fetchWithAuth({
        endpointUrl: this.endpointUrl,
        route: "api/v1/accounts/".concat(accountId)
      })["catch"](function (e) {
        var statusCode = (0, _lodash["default"])(e, 'response.status');

        switch (statusCode) {
          case 401:
            throw new Error('You are not logged in. Please refresh the page and try again.');

          case 403:
            throw new Error("You don't have permission to this account (".concat(accountId, ")."));

          default:
            throw new Error("An unknown error occurred when fetching account. (".concat(statusCode, ")"));
        }
      });
    }
  }]);
  return AccountsClient;
}(_BaseClient2["default"]);

exports["default"] = AccountsClient;